export const COUNTRY = 'country';
export const TRANSACTION_STATUS = {
    APPROVED: 'Aprobada',
    REJECTED: 'Rechazada',
    PENDING: 'Pendiente',
};

export const TRANSACTION_ERRORS = {
    GENERIC_STATUS_ERROR: 'Ha ocurrido un error al procesar el pago, por favor inténtalo más tarde',
    PROCESSING_PAYMENT_ERROR: 'Ha ocurrido un error al procesar el pago, por favor inténtalo más tarde',
};

export const CREATE_TRANSACTION_ERRORS: { [key: number]: string } = {
    50003: 'Ha ocurrido un error al procesar el pago, por favor inténtalo más tarde',
    50004: 'En este momento tiene una transacción en curso para ser activada',
    59999: 'Ocurrió un error al obtener el estado de la transacción',
};

export const MAX_DAYS_DIFF = 3;
